import { render, staticRenderFns } from "./r-delete-button.vue?vue&type=template&id=b6a28aa8&scoped=true"
import script from "./r-delete-button.vue?vue&type=script&lang=js"
export * from "./r-delete-button.vue?vue&type=script&lang=js"
import style0 from "./r-delete-button.vue?vue&type=style&index=0&id=b6a28aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a28aa8",
  null
  
)

export default component.exports